/* eslint-disable */
import React from 'react';
import CloseIcon from '@mui/icons-material/Close';

// compoennts
import { Chip } from '@mui/material';
import { Box } from '@mui/system';

// constants
import { MAX_ALLOWED_GROUPS } from '../groupsTable/groupsTable.constants';

// helpers
import { getGroupsWithColour } from '../../../../../../helpers/user';

// styles
import styles from './viewGroups.module.scss';

const renderChip = ({ selectedGroup, handleDelete }) => (
  <Chip
    label={selectedGroup?.display || selectedGroup?.value}
    onDelete={() => handleDelete(selectedGroup?.value)}
    variant="outlined"
    sx={{
      fontSize: '14px !important',
      font: 'Johnson Text !important'
    }}
    deleteIcon={<CloseIcon
      sx={{
        color: 'black !important',
        fontSize: '18px !important',
      }}
      data-testid='CancelIcon'
    />}
  />
)

const ViewGroups = ({ selectedGroups, setSelectedGroups, getSelectedGroupsCount, displayAlert }) => {
  const handleDelete = (deletedGroupId) => {
    const updatedSelectedGroups = selectedGroups.filter((selectedGroup) => selectedGroup?.value !== deletedGroupId)
    const selectedGroupsCount = getSelectedGroupsCount(updatedSelectedGroups)
    if (selectedGroupsCount > MAX_ALLOWED_GROUPS) {
      displayAlert(true)
    } else {
      displayAlert(false)
      setSelectedGroups(updatedSelectedGroups)
    }
  };
  const selectedGroupsWithColour = getGroupsWithColour(selectedGroups);
  return (
    <>
      {
        selectedGroupsWithColour?.length > 0 && (
          <Box className={styles.gridClass}>
            {selectedGroupsWithColour?.map((selectedGroup) => renderChip({ selectedGroup, handleDelete }))}
          </Box>
        )
      }
    </>
  )
}

export default ViewGroups;
